import React from 'react';

import { useLocation } from 'react-router-dom';
import { useRouteChangeHandler } from 'shared/hooks';
import { useInfoStore } from 'store/useInfoStore';

import { NavList } from '../constants';
import AppHeaderItem from './AppHeaderItem';
import AuthButtons from './AuthButtons';
import ServiceIcons from './ServiceIcons';
import UserDropdownMenu from './UserDropdownMenu';

// TODO: Header 부분을 fsd 구조에 맞게 리팩토링 합니다
const AppHeader = () => {
  const { handleRouteChange } = useRouteChangeHandler();
  const { accessToken, firstName } = useInfoStore();

  const { pathname, search } = useLocation();

  const isLogin = !!accessToken;

  const name = firstName.length >= 6 ? `${firstName.slice(0, 6)}...` : firstName;

  return (
    <div className="sticky top-0 z-30 flex h-[99px] w-full min-w-full items-center justify-center bg-white">
      <div className={`mx-auto flex w-full max-w-[1440px] items-center justify-between px-6`}>
        <a
          href={`${pathname}${search}#footer-content`}
          className="skip-link fixed left-0 right-0 top-0 z-[100] -translate-y-full bg-black p-2 text-center text-white outline-none transition-transform duration-150 focus:translate-y-0"
        >
          Skip to main footer
        </a>

        <div className="flex items-center gap-x-12.5">
          <button onClick={() => handleRouteChange('/')}>
            <img src="/images/optimized/checkmate_logo.webp" alt="logo" className="h-9 w-auto cursor-pointer" />
          </button>

          <nav className="flex items-center gap-x-[30px]">
            {NavList.map(({ title, to, target, subMenu }, idx) => (
              <AppHeaderItem key={idx} title={title} to={to} target={target} subMenu={subMenu} />
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-x-6.25">
          <ServiceIcons isLogin={isLogin} />

          {!isLogin ? <AuthButtons isLogin={isLogin} /> : <UserDropdownMenu name={name} />}
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
